// eslint-disable-next-line
import ProjectEvaluations from '@/api/resources/project_evaluations';

const state = {
  projectEvaluations: null,
  projectToEvaluate: null,
  successUpdate: false,
  hasPendingEvaluations: false,
};

const getters = {
  getProjectEvaluations: () => state.projectEvaluations,
  getProjectToEvaluate: () => state.projectToEvaluate,
  getSuccessUpdate: () => state.successUpdate,
  getHasPendingEvaluations: () => state.hasPendingEvaluations,
};

const actions = {
  fetchProjectEvaluations({ commit, dispatch }, params) {
    dispatch('initLoading');
    const query = {
      by_project_kind: params,
    };
    ProjectEvaluations.index(query).then((response) => {
      commit('setProjectEvaluations', response);
      dispatch('removeLoading');
    });
  },

  fetchHasPendingEvaluations({ commit }) {
    ProjectEvaluations.hasPendingEvaluations().then((response) => {
      commit('setHasPendingEvaluations', response.has_pending_evaluations);
    });
  },

  addProjectToEvaluate({ commit }, payload) {
    commit('setprojectToEvaluate', payload);
  },
  updateEvaluation({ commit, dispatch }, payload) {
    dispatch('initLoading');
    ProjectEvaluations.update(payload.evaluationId, payload.data).then(() => {
      commit('setSuccessUpdate');
      dispatch('removeLoading');
    });
  },
  changeEvaluationSuccess({ commit }) {
    commit('setSuccessUpdate');
  },
};

const mutations = {
  setProjectEvaluations($state, payload) {
    const stateCopy = $state;
    stateCopy.projectEvaluations = payload;
  },
  setprojectToEvaluate($state, payload) {
    const stateCopy = $state;
    stateCopy.projectToEvaluate = payload;
  },
  setSuccessUpdate($state) {
    const stateCopy = $state;
    stateCopy.successUpdate = !stateCopy.successUpdate;
  },
  setHasPendingEvaluations($state, payload) {
    const stateCopy = $state;
    stateCopy.hasPendingEvaluations = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
